// import jwtDecode from 'jwt-decode';
import { API_BASE_URL } from 'src/config';
import { post, update, get, remove } from 'src/utils/rest';
import ENDPOINTS from 'src/constants/endpoints';
import { resHandler, errorHandler } from 'src/utils/functions';

class WishService {
createWish = data => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.CREATE_WISH, data, true, false)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
getWish = id => new Promise((resolve, reject) => {
    get(API_BASE_URL + ENDPOINTS.GET_WISH + id)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
updateWish = (id, data) => new Promise((resolve, reject) => {
    update(API_BASE_URL + ENDPOINTS.UPDATE_WISH + id, data, true, false)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
deleteWish = id => new Promise((resolve, reject) => {
    remove(API_BASE_URL + ENDPOINTS.DELETE_WISH + id, null, true,)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
load = data => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.LOAD_WISHES, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
loadReceived = data => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.LOAD_RECEIVED, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
loadUserWishItems = data => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.LOAD_USER_WISHES, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
loadUserWishItemsPublic = data => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.LOAD_USER_WISHES_PUBLIC, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
loadUserPurchasedItems = data => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.LOAD_USER_PURCHASED, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
loadUserPurchasedItemsPublic = data => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.LOAD_USER_PURCHASED_PUBLIC, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
}

const wishService = new WishService();

export default wishService;
